import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { OptionRendererProps } from '../common/form/widgets/OptionRendererProps';
import { Contact } from 'sr-types/lib/production/v1/graphql';
import { LabelValueDisplay } from '../attributes/AttributeValue';
import { UserContext } from '../common/auth/UserContext';
import useHistory from '../common/utils/useHistory';
import { hyperlinkSx } from '../common/utils/commonUtils';
import { getFullName } from './person';
import { useStyling } from '../common/Theme';
import { Icons } from '../common/icons/Icons';
import { H } from '../common/Layout';
import { useI18n } from '../common/i18n/I18n';

export default (props: OptionRendererProps<Contact>) => {
    const { option: contact, sx, getSubLabel, enableHyperlink = false, valueSx, labelSx } = props;
    const { organization, role, production, productionRole, personReference } = contact;
    const { application } = useContext(UserContext);
    const { changeRoute } = useHistory();
    const { theme } = useStyling();
     const searchAndClearAllText = useI18n('common.clear.and.search.all', { label: '' });  
    const name = getFullName(contact.name);
    const isClearAndSearchOption = name.includes(searchAndClearAllText);
    let subLabel = '';
    if (typeof getSubLabel === 'function') {
        subLabel = getSubLabel(contact);
    } else {
        const email = contact.contactInfo?.email?.address ?? 'No Email Available';
        const organizationInfo = [organization, role].filter(Boolean).join(', ');
        const productionInfo = [production, productionRole].filter(Boolean).join(', ');
        subLabel = [email, organizationInfo, productionInfo].filter(Boolean).join(' | ');
    }
    return (
        <H gap={1} sx={sx}>
            {isClearAndSearchOption &&
                <Icons.Close />
            }
            <LabelValueDisplay
                label={subLabel}
                value={name}
                labelOnTop={false}
                labelSx={{ fontWeight: '300', ...labelSx }}
                valueSx={{
                    fontWeight: 'medium',
                    ...(enableHyperlink && hyperlinkSx),
                    ...valueSx
                }}
                onClickValue={
                    enableHyperlink
                        ? (event: React.MouseEvent<HTMLButtonElement>) => {
                              event.stopPropagation();
                              changeRoute(`${application.home}/people/${personReference?.id}/details`);
                          }
                        : undefined
                }
            />
        </H>
    );
};
